import React from 'react';
import { formatLeaveStatusLabel, getLeaveStatusBadgeClass } from '../../utils/leaveStatus';

function LeaveStatusBadge({ status, className = '' }) {
  const label = formatLeaveStatusLabel(status);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${getLeaveStatusBadgeClass(
        status
      )} ${className}`}
    >
      {label}
    </span>
  );
}

export default LeaveStatusBadge;
